import { useCallback, useEffect, useState } from "react";

import { checarReabertura } from "./api";

/** Consulta a reabertura do pedido aberto no detalhe. Refaz quando o status
 *  muda (reabriu, fechou de novo) — o servidor é quem sabe do caixa. */
export function useReabertura(pedido, aberto) {
  const [info, setInfo] = useState(null);
  const id = pedido?.id;
  const status = pedido?.status;
  const recarregar = useCallback(() => {
    if (!id) return Promise.resolve();
    return checarReabertura(id).then(setInfo).catch(() => setInfo(null));
  }, [id]);
  useEffect(() => {
    setInfo(null);
    if (aberto && id) recarregar();
  }, [aberto, id, status, recarregar]);
  return { info, recarregar };
}
